import { jsx as _jsx } from "react/jsx-runtime";
import { ApplicantInformationView } from "./view";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { navigateBack, navigateNext, stepProgress, } from "../../../dataBase/stepProgress";
import { STEP_APPLICANTINFORMATION } from "../../../const/catalog";
import { useTranslation } from "react-i18next";
import LocalStorageService from "../../../services/localStorage";
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
var STEP = STEP_APPLICANTINFORMATION;
export var ApplicantInformation = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var _a = React.useState([]), steps = _a[0], setSteps = _a[1];
    var _b = React.useState([]), breadCrumbs = _b[0], setBreadCrumbs = _b[1];
    useEffect(function () {
        setBreadCrumbs(stepProgress(STEP, true));
        setSteps(stepProgress(STEP));
    }, []);
    var onClickSaveForm = function (data) {
        console.log("Data", data);
        // localStorageService.setStepStored({
        //   id: "",
        //   name: "ApplicantIformation",
        //   step: Steps.applicantInformation,
        //   completed: true,
        //   applicantInformation: data,
        // });
    };
    var onNextStep = function () {
        navigateNext(STEP, navigate);
    };
    var onBackStep = function () {
        navigateBack(STEP, navigate);
    };
    return (_jsx(ApplicantInformationView, { breadCrumbs: breadCrumbs, steps: steps, t: t, onClickSaveForm: onClickSaveForm, onNextStep: onNextStep, onBackStep: onBackStep }));
};
